var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#ED2024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25 69.5334V160.733L225.72 174.983L197.22 202.913L210.9 220.013L241.11 188.663L247.95 201.773L230.85 229.703L251.37 261.623L241.11 276.443L257.07 296.963L272.46 275.873L263.91 261.053L281.01 227.993L265.62 201.773L272.46 188.663L302.1 220.013L316.35 203.483L286.71 174.413L327.75 159.593V69.5334L298.11 80.3634L297.54 102.023L278.73 103.733V88.9134L288.42 75.8034L320.34 63.2634L307.23 60.9834L315.21 54.1434L320.34 56.4234L315.78 48.4434L307.8 51.2934L302.1 45.0234L270.75 51.2934L278.73 57.5634L257.07 85.4934L235.41 58.1334L242.82 51.8634L214.32 45.0234L206.34 51.2934L197.79 49.0134L193.23 56.9934L198.36 53.5734L207.48 59.8434L194.37 62.6934L225.72 74.0934L234.84 87.2034V103.733L216.03 102.023V81.5034L185.25 69.5334Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.34 142.494H185.82V156.744H149.34V142.494ZM149.34 119.124H185.82V134.514H149.34V119.124ZM149.34 95.1838H185.82V110.004H149.34V95.1838ZM149.34 72.3838H185.82V86.6338H149.34V72.3838Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.18 142.494H363.66V156.744H327.18V142.494ZM327.18 119.124H363.66V134.514H327.18V119.124ZM327.18 95.1838H363.66V110.004H327.18V95.1838ZM327.18 72.3838H363.66V86.6338H327.18V72.3838Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.38 205.765H340.86V216.595H304.38V205.765ZM172.14 205.765H208.62V216.595H172.14V205.765Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAl);
export default __webpack_public_path__ + "static/media/AL.f42bae081eae9e8e24c2958b54477141.svg";
export { ForwardRef as ReactComponent };